import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './style.css';

function HistorySection() {
  return (
    <section
      id="our-story"
      className="history-section"
    >
      <Container>
        <Row className="justify-content-center">
          <Col lg="10">
            <div className="history-header text-center mb-5">
              <h2 className="history-title">
                Our Story
              </h2>
              <div className="history-subtitle">
                Technology with purpose, strategy with soul: 15 years transforming brands through trust, innovation, and results.
              </div>
            </div>
            <div className="history-body">
              <p>
                Fifteen years ago, we started with a clear idea: help brands tell their story and thrive in the digital world. Social media was still emerging, but we already knew digital transformation wasn’t a trend — it was the future.
              </p>
              <p>
                Along the way, we met hundreds — even thousands — of businesses abandoned by agencies that overpromised and underdelivered. Brands full of potential, effort, and vision, but without the support they deserved.
              </p>
              <p>
                That left a mark on us. We decided to be different.
              </p>
              <p>
                At SJ Social Media, we focus on building long-term relationships rooted in trust, results, and true partnership. Because strategy without people behind it means nothing. Web development, automation, or AI only matter when used with purpose.
              </p>
              <p>
                That’s why we became pioneers in bringing accessible AI solutions to real businesses — helping them automate, optimize, and grow without losing their human essence.
              </p>
              <p>
                Today, after more than a decade, we still believe that every company — no matter its size — deserves a team that listens, solves, and shows up. We are not just another agency. We are the digital ally that never lets go of your hand.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default HistorySection;
